import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Grid, Button, Box, TextField } from '@material-ui/core';
import DatePicker from '../global/DatePicker';
import { months } from '../../utils/data/months';
import { channels as channelsData } from '../../utils/data/channels';

interface PanelFilterProps {
  onSubmit: (any) => void;
  yearMonth?: boolean;
  year?: boolean;
  channels?: boolean;
  refButton?: any;
}

const PanelFilter: FC<PanelFilterProps> = ({
  onSubmit,
  yearMonth = false,
  year = false,
  channels = false,
  refButton,
}) => {
  const currentDate = new Date();
  const [formFilter, setFormFilter] = useState({
    startDate: new Date(),
    endDate: new Date(),
    year: currentDate.getFullYear(),
    month: currentDate.getMonth() + 1,
    channel: 'all',
  });

  const onChange = (name, value) => {
    setFormFilter((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const getDateString = (dateParam: Date): string => {
    const month = dateParam.getMonth() + 1;
    const day = dateParam.getDate();
    const monthString = month > 9 ? `${month}` : `0${month}`;
    const dayString = day > 9 ? `${day}` : `0${day}`;
    return `${dateParam.getFullYear()}-${monthString}-${dayString}`;
  };

  const onSubmitLocal = () => {
    const params = {
      year: Number(`${formFilter.year}`),
      month: Number(`${formFilter.month}`),
      startDate: getDateString(formFilter.startDate),
      endDate: getDateString(formFilter.endDate),
      channels: channels ? formFilter.channel : undefined,
    };
    onSubmit(params);
  };

  useEffect(() => {
    onSubmitLocal();
  }, []);

  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <Grid item xl={2} md={2} xs={6}>
          {!yearMonth && !year && (
            <DatePicker
              value={formFilter.startDate}
              label="Desde:"
              name="startDate"
              onChange={onChange}
            />
          )}
          {(yearMonth || year) && (
            <TextField
              label="Ańo:"
              name="year"
              value={formFilter.year}
              size="small"
              fullWidth
              onChange={(e) => {
                onChange(e.target.name, e.target.value);
              }}
            />
          )}
        </Grid>
        {!yearMonth && !year && (
          <Grid item xl={2} md={2} xs={6}>
            <DatePicker
              value={formFilter.endDate}
              label="Hasta:"
              name="endDate"
              onChange={onChange}
            />
          </Grid>
        )}
        {yearMonth && (
          <Grid item xl={2} md={3} xs={6}>
            <TextField
              label="Mes:"
              name="month"
              value={formFilter.month}
              fullWidth
              select
              size="small"
              SelectProps={{ native: true }}
              onChange={(e) => {
                onChange(e.target.name, e.target.value);
              }}
            >
              {months.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
            </TextField>
          </Grid>
        )}
        {channels && (
          <Grid item xl={2} md={3} xs={6}>
            <TextField
              label="Canales de Ventas:"
              name="channel"
              value={formFilter.channel}
              fullWidth
              select
              size="small"
              SelectProps={{ native: true }}
              onChange={(e) => {
                onChange(e.target.name, e.target.value);
              }}
            >
              {channelsData.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.name}
                </option>
              ))}
            </TextField>
          </Grid>
        )}
        <Grid item xs={12} md={2}>
          <Button
            color="primary"
            variant="contained"
            fullWidth
            onClick={onSubmitLocal}
            ref={refButton}
          >
            Consultar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PanelFilter;
